import { ServiceClient } from 'src/utils'
import { SimpleUserWithGroups, UserChangePasswordRequestData, UserRow } from './um_scopes'

const serviceClient = ServiceClient.singleton()

export class UserManagerService {
    static #INSTANCE = new UserManagerService()
    static readonly singleton = () => UserManagerService.#INSTANCE

    async fetchUsers(nameFilter?: string, showDeleted?: boolean): Promise<UserRow[]> {
        const data = await serviceClient.authGet<UserRow[]>(
            `/api/user-manager?name=${nameFilter || ''}&showDeleted=${!!showDeleted}`
        )
        return data
    }

    async fetchSimpleUsersWithGroups(): Promise<SimpleUserWithGroups[]> {
        const data = await serviceClient.authGet<SimpleUserWithGroups[]>('/api/user-manager/valid-with-groups')
        return data
    }

    async fetchUserById(userId: number): Promise<UserRow> {
        const data = await serviceClient.authGet<UserRow>(`/api/user-manager/${userId}`)
        return data
    }

    async createUser(user: UserRow): Promise<UserRow> {
        const data = await serviceClient.authPost<UserRow>('/api/user-manager', user)
        return data
    }

    async updateUser(userId: number, user: UserRow): Promise<UserRow> {
        const data = await serviceClient.authPut<UserRow>(`/api/user-manager/${userId}`, user)
        return data
    }

    async changeUserPassword(userId: number, requestPassChangeData: UserChangePasswordRequestData): Promise<UserRow> {
        const data = await serviceClient.authPost<UserRow>(
            `/api/user-manager/change-password/${userId}`,
            requestPassChangeData
        )
        return data
    }

    async deleteUser(userId: number): Promise<void> {
        return serviceClient.authDelete(`/api/user-manager/${userId}`)
    }

    async restoreUser(userId: number): Promise<void> {
        return serviceClient.authPost(`/api/user-manager/restore/${userId}`)
    }
}

export default UserManagerService.singleton()
